import { render, staticRenderFns } from "./ListFieldTags.vue?vue&type=template&id=1f2bb518"
import script from "./ListFieldTags.vue?vue&type=script&lang=js"
export * from "./ListFieldTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports